export const EMPTY_STRING_ARRAY: string[] = [];
